//Dependencies............................................
import React, { useEffect, useState } from "react";
import axios from 'axios';
import {Input, Modal, Form} from 'antd';
import {
    useQueryClient,
    useMutation,
} from '@tanstack/react-query'

//Components..............................................
import {BASE_URL} from '../../../utils/constants';
import {JsonSchemaItem} from "../../../utils/interfaces";
import { NotificationInstance } from "antd/es/notification/interface";

interface Props {
  showModal: boolean,
  onClose: () => void
  api: NotificationInstance
}

const AddJsonSchemaListModal: React.FC<Props> = ({ showModal, onClose: onCancel, api }: Props) => {

  const [form] = Form.useForm<JsonSchemaItem>();
  const [submittable, setSubmittable] = useState(false);

  const watchedValues = Form.useWatch([], form);
  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, watchedValues]);

  const queryClient = useQueryClient()

  const addJsonSchema = useMutation({
    // mutationFn: (values: JsonSchemaItem) => axios.post(`${BASE_URL}generate_json_schema_base`, values),
    mutationFn: (values: JsonSchemaItem) => {
    return axios.post(`${BASE_URL}/generate_json_schema_base`, values, {
        headers: {
        // Overwrite Axios's automatically set Content-Type
        'Content-Type': 'application/json'
      }})
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jsonSchemaList'] })
      queryClient.invalidateQueries({ queryKey: ['baseFirmwareList'] })
      queryClient.invalidateQueries({ queryKey: ['vehicleList'] })
    }
  })

  const onFinish = (values: JsonSchemaItem) => {
    console.log('Received values of form: ', values);
    values.json_schema = JSON.parse(values.json_schema as string)
    addJsonSchema.mutate(values, {
      onSuccess: () =>  {
        onCancel()
        api.success({
          title: 'JSON Schema Added',
          description: `JSON Schema ${values.version_schema_name} added successfully.`,
          placement: 'bottomRight',
          showProgress: true
        });
      },
      onError: (error) => {
        api.error({
          title: 'Error Adding JSON Schema',
          description: `Failed to add JSON Schema: ${error.message}`,
          placement: 'bottomRight',
          showProgress: true
        });
      }
    });
  };

  useEffect(() => {
    if (showModal) {
      form.resetFields();
    }
  }, [showModal, form]);

  return(
    <Modal
      title="Add New JSON Schema"
      open={showModal}
      okText="Add"
      cancelText="Cancel"
      okButtonProps={{
        autoFocus: false,
        htmlType: 'submit',
        loading: addJsonSchema.isPending,
        disabled: !submittable || addJsonSchema.isPending,
      }}
      cancelButtonProps={{ disabled: addJsonSchema.isPending }}
      closable={!addJsonSchema.isPending}
      mask={{ closable: !addJsonSchema.isPending }}
      onCancel={onCancel}
      modalRender={(dom) => (
        <Form
          layout="vertical"
          form={form}
          name="form_add_json_schema"
          clearOnDestroy
          onFinish={(values) => onFinish(values)}
        >
          {dom}
        </Form>
      )}
    >
      <Form.Item
        name="version_schema_name"
        label="JSON Schema Version"
        // initialValue={"CONF 1.0"}
        rules={[
          {
            required: true,
            validator: (_, value: string) =>{
              if(value) {
                const re = /^CONF \d.\d$/g;
                value.match(re)
                if(value.match(re)) {
                  return Promise.resolve()
                } else {
                  return Promise.reject(new Error('Version should match next rule "CONF x.y"'))
                }
              } else {
                return Promise.reject(new Error('Please enter value'))
              }
            }
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="json_schema"
        label="JSON Schema"
        // initialValue={"{}"}
        rules={[
          {
            required: true,
            validator: (_, value: string) =>{
                  if(value) {
                      try {
                          JSON.parse(value);
                          return Promise.resolve()
                      } catch (e) {
                          return Promise.reject(new Error('Invalid JSON'))
                      }
                  } else {
                      return Promise.reject(new Error('Please enter JSON Schema'))
                  }
              }
          },
        ]}>
        <Input.TextArea rows={30} />
      </Form.Item>
    </Modal>
  )
}
export default AddJsonSchemaListModal;

